__turbopack_context__.v({
  "left_fade_out": "_5IyMMW_left_fade_out",
  "right_fade_out": "_5IyMMW_right_fade_out",
});
